import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Button,
  TextField,
  Chip,
  Tabs,
  Tab,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  Menu,
  MenuItem,
  InputAdornment,
  Tooltip,
} from '@mui/material';
import { PlayArrow, GridView, TableView, MoreVert } from '@mui/icons-material';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import axiosInstance from '../../../../../api/apiClient';
import { useLocation, useNavigate } from 'react-router-dom';
import AlertsGrid from './AlertDataGrid';
import AlertsTable from './AlertDataTable';
import CallMadeIcon from '@mui/icons-material/CallMade';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import Custom from 'packages/novous_web/src/assets/icons/CustomBlue.svg';
import calendar from 'packages/novous_web/src/assets/icons/calendar.svg';
import GridTab from 'packages/novous_web/src/iconComponent/GridTab';
import TableTab from 'packages/novous_web/src/iconComponent/TableTab';
import DateRangeFilter from 'packages/novous_web/src/common/components/DateRange';
import dayjs from 'dayjs';
import arrow from 'packages/novous_web/src/assets/icons/Arrow.svg';
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg';
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg';
import { getWarningIcon } from '../helper/warningIcons';
import CustomiseTableModal from 'packages/novous_web/src/common/components/CustomiseTable';
import { MRT_ColumnDef } from 'material-react-table';
import infoIcon from '../../../../../assets/icons/i.svg';
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import FilterDataModel from 'packages/novous_web/src/common/components/FilterDataModal';
import Loader from 'packages/novous_web/src/common/components/Loader';

interface Alert {
  id: string;
  driverName: string;
  vehicleNumber: string;
  timestamp: string;
  gpsSpeed: number;
}

interface WarningData {
  warningName: string;
  alerts: Alert[];
}

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};
interface AlertDataTableProps {
  handleTile: (data: ColumnObjType) => void;
  setEndTileDate?: any;
  setStartTileDate?: any;
  filters?: any;
  setFilters?: any;
  clearFilters?: () => void;
  filterData?: { data: any; isfiltered: boolean };
}
const Dashboard: React.FC<AlertDataTableProps> = ({
  handleTile,
  setEndTileDate,
  setStartTileDate,
  filters,
  setFilters,
  clearFilters,
  filterData,
}) => {
  const shouldHideWarning = (warningName: string) => {
    if (user?.id === '685e1eec79b388464c5cd08e') {
      const warningsToHide = ['Vehicle Idling', 'Geo Fence Alert', 'Geofence Overspeed Violation'];
      return warningsToHide.includes(warningName);
    }
    return false;
  };

  const theme = useTheme();
  const { user } = useAuth();
  const location = useLocation();
  const state = location.state || {};
  const [warnings, setWarnings] = useState<any>(null);
  const [criticalWarning, setCriticalWarning] = useState<any>([]);
  const [nonCriticalWarning, setNonCriticalWarning] = useState<any>([]);
  const [alertsMap, setAlertsMap] = useState<{ [key: string]: { alerts: any[] } }>({});
  const [warningType, setWarningType] = useState<any>();
  const alertsDataArr: any = [];
  const [allWarningTypes, setAllWarningTypes] = useState<any>([]);
  const [newData, setNewData] = useState<WarningData[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [calendarAnchorEl, setCalendarAnchorEl] = useState<null | HTMLElement>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const [filteredData, setFilteredData] = useState<any>();
  const [showDatePicker, setShowDatePicker] = useState(false);
  const dateRangeArr = ['Today', 'Yesterday', '7 Days', '15 Days', '30 Days', 'Custom Range'];
  const [selectedDuration, setSelectedDuration] = useState(state?.selectedDuration || dateRangeArr[0]);
  const [enabledWarnings, setEnabledWarnings] = useState<Record<string, boolean>>({});

  // Initialize with today's date if no state values are provided
  const getInitialDateRange = (duration: string) => {
    if (state?.startDate && state?.endDate) {
      return { startDate: state.startDate, endDate: state.endDate };
    }
    const today = dayjs();
    return { startDate: today.format('YYYY-MM-DD'), endDate: today.format('YYYY-MM-DD') };
  };

  const initialDates = getInitialDateRange(selectedDuration);
  const [startDate, setStartDate] = useState(initialDates.startDate);
  const [endDate, setEndDate] = useState(initialDates.endDate);
  const { data: alert1Data, fetchData: fetch1AlertData } = useAxios<any>(
    `${API_ENDPOINTS.alarm.VEHICLE_ALERT_ALL_WARNING}`,
    'POST',
  );
  const [isFilterModel, setIsFilterModelOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<'all' | 'critical' | 'nonCritical'>('all');
  const [viewMode, setViewMode] = useState<'grid' | 'table'>(state.viewMode || 'grid');
  const navigate = useNavigate(); // Add from react-router-dom
  const handleFilterClose = () => setIsFilterModelOpen(false);
  const handleFilterOpen = () => setIsFilterModelOpen(true);
  useEffect(() => {
    if (user?.customer_id) {
      const payload: any = {
        fleetId: user.customer_id,
        startDate,
        endDate,
      }
      if(filterData?.isfiltered && filterData?.data){
        if(filterData.data.vehicleGroup){
          payload.vehicleGroup=filterData.data.vehicleGroup
        }
      }
      fetch1AlertData(payload);
    }
  }, [user]);

  // Initialize tile dates on component mount
  useEffect(() => {
    if (startDate && endDate) {
      setStartTileDate(startDate);
      setEndTileDate(endDate);
    }
  }, []); // Only run once on mount

  useEffect(() => {
    if (alert1Data?.data) {
      setWarnings(alert1Data.data);
      setCriticalWarning(alert1Data.data.criticalWarningType || []);
      setNonCriticalWarning(alert1Data.data.nonCriticalWarningType || []);
      setAllWarningTypes([
        ...(alert1Data.data.criticalWarningType || []),
        ...(alert1Data.data.nonCriticalWarningType || []),
      ]);
    }
  }, [alert1Data]);
  // Get filters directly from URL parameters instead of state
  const urlFilters = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      group: params.get('depotName') || undefined,
      vehicle: params.get('vehicleId') || undefined,
    };
  }, [location.search]);

  // useEffect(() => {
  //   if (activeTab === 'all') {
  //     fetchAllAlertsParallel(allWarningTypes, urlFilters.group, urlFilters.vehicle);
  //   } else if (activeTab === 'critical') {
  //     fetchAllAlertsParallel(criticalWarning, urlFilters.group, urlFilters.vehicle);
  //   } else if (activeTab === 'nonCritical') {
  //     fetchAllAlertsParallel(nonCriticalWarning, urlFilters.group, urlFilters.vehicle);
  //   }
  // }, [activeTab, allWarningTypes, criticalWarning, nonCriticalWarning, urlFilters]);
  useEffect(() => {
    const { startDate: newStartDate, endDate: newEndDate } = getDateRange(selectedDuration);
    setStartDate(newStartDate);
    setStartTileDate(newStartDate);
    setEndTileDate(newEndDate);
    setEndDate(newEndDate);
  }, [selectedDuration, setStartTileDate, setEndTileDate]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlViewMode = params.get('viewMode') as 'grid' | 'table';

    // Keep duration filter completely local - never read from URL parameters
    // Only set from state if it exists
    if (Object.keys(state).length > 0 && state.selectedDuration) {
      setSelectedDuration(state.selectedDuration || dateRangeArr[0]);
    }

    // Keep start/end dates local as well - only set from state
    if (Object.keys(state).length > 0) {
      setStartDate(state.startDate || '');
      setEndDate(state.endDate || '');
    }

    if (urlViewMode) {
      setViewMode(urlViewMode);
    } else if (state.viewMode) {
      setViewMode(state.viewMode || 'grid');
    }
  }, [location.search, state]);

  const fetchAllAlertsParallel = async (
    warningTypes: string[],
    vehicleGroup?: string,
    vehicleId?: string,
  ) => {
    try {
      setLoading(true);
      setError(null);

      const requests = warningTypes.map((warningType) =>
        axiosInstance({
          url: API_ENDPOINTS.alarm.VEHICLE_PAGINATED_ALERT_BY_WARNING,
          method: 'POST',
          data: {
            fleetId: user?.customer_id,
            startDate: startDate,
            endDate: endDate,
            warningType,
            lastEvaluatedKey: null,
            ...(vehicleGroup && { vehicleGroup: vehicleGroup }),
            ...(vehicleId && { vehicleId: vehicleId }),
            ...(filterData?.isfiltered && filterData?.data?.vehicleGroup && { vehicleGroup: filterData.data.vehicleGroup }),
          },
          responseType: 'json',
        })
          .then((response) => ({
            warningName: warningType,
            alerts: response.data || [],
          }))
          .catch((error) => ({
            warningName: warningType,
            alerts: [],
            error: error.message,
          })),
      );

      const results = await Promise.all(requests);
      const searchTerm = searchQuery.toLowerCase().trim();

      const processedResults = results.map((result: any) => {
        const warningName = result.warningName || '';
        const isWarningMatch = warningName.toLowerCase().includes(searchTerm);
        const rawAlerts = Array.isArray(result.alerts?.data?.actualWarningList)
          ? result.alerts.data.actualWarningList
          : [];

        return {
          warningName: warningName,
          totalRecords: result.alerts?.data?.totalRecords || 0,
          alerts: isWarningMatch
            ? rawAlerts
            : rawAlerts.filter((alert: any) => {
                return [
                  alert?.vehicleNumber?.toLowerCase(),
                  alert?.device_id?.toLowerCase(),
                  alert?.vehicleId?.toLowerCase(),
                ].some((field) => field?.includes(searchTerm));
              }),
          isCritical: criticalWarning.includes(warningName),
        };
      });

      const filteredResults = processedResults.filter(
        (result) => result.alerts.length > 0 || result.warningName.toLowerCase().includes(searchTerm),
      );

      const finalResults = filteredResults.map((result) => ({
        ...result,
        isCritical: criticalWarning.includes(result.warningName),
      }));

      setNewData(finalResults);
      return finalResults;
    } catch (error) {
      setError(error instanceof Error ? error.message : 'Unknown error occurred');
      return [];
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (startDate && endDate) {
      const selectedWarningTypes =
        activeTab === 'all'
          ? allWarningTypes
          : activeTab === 'critical'
          ? criticalWarning
          : nonCriticalWarning;

      fetchAllAlertsParallel(selectedWarningTypes, urlFilters.group, urlFilters.vehicle);
    }
  }, [
    startDate,
    endDate,
    debouncedSearchQuery,
    urlFilters,
    activeTab,
    allWarningTypes,
    criticalWarning,
    nonCriticalWarning,
  ]);

  const formatTimestamp = (timestamp: string) => {
    const [year, month, day, hour, minute, second] = timestamp?.split('_');
    const date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
    return date
      .toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      })
      .replace(',', '');
  };

  const getDateRange = (range: string) => {
    const today = dayjs();
    let startDate, endDate;

    switch (range) {
      case 'Today':
        startDate = today.format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case 'Yesterday':
        startDate = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
        endDate = startDate;
        break;
      case '7 Days':
        startDate = dayjs().subtract(6, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case '15 Days':
        startDate = dayjs().subtract(14, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case '30 Days':
        startDate = dayjs().subtract(29, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      default:
        startDate = '';
        endDate = '';
    }
    return { startDate, endDate };
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setCalendarAnchorEl(event.currentTarget);
  };
  const handleCalendarClose = () => {
    setShowDatePicker(false);
    setCalendarAnchorEl(null);
  };
  const handleClose = (value?: string) => {
    if (value) {
      // Only reset dates if changing FROM custom range TO another option
      if (selectedDuration === 'Custom Range' && value !== 'Custom Range') {
        const { startDate: newStartDate, endDate: newEndDate } = getDateRange(value);
        setStartDate(newStartDate);
        setEndDate(newEndDate);
      }

      setSelectedDuration(value);
      setShowDatePicker(value === 'Custom Range');

      // If selecting Custom Range again, don't reset the dates - keep existing values
      if (value === 'Custom Range') {
        setCalendarAnchorEl(anchorEl); // Keep the anchor for the date picker
      }
    }

    setAnchorEl(null);
  };

  const handleViewAll = (warning: any) => {
    const params = new URLSearchParams();
    const warningData: any = newData.find((item) => item.warningName === warning);
    params.set('warningName', warning);
    if (warningData) {
      params.set('isCritical', warningData.isCritical ? 'true' : 'false');
    }
    if (viewMode) {
      params.set('viewMode', viewMode);
    }
    // Use URL filters instead of state filters
    if (urlFilters.group) {
      params.set('depotName', urlFilters.group);
    }
    if (urlFilters.vehicle) {
      params.set('vehicleId', urlFilters.vehicle);
    }
    if (filterData?.isfiltered && filterData?.data){
      if(filterData.data.vehicleGroup){
        params.set('depotName', filterData.data.vehicleGroup);
      }
    }

    // Pass current state so the "View All" page can read duration filter from state
    navigate(`/alarm/vehicle-all-alerts?${params.toString()}`, {
      state: {
        selectedDuration: selectedDuration,
        startDate: startDate,
        endDate: endDate,
        viewMode: viewMode,
      },
    });
  };

  const [isCustomiseModalOpen, setIsCustomiseModalOpen] = useState(false);

  const handleCustomiseModalOpen = (event: any) => {
    setIsCustomiseModalOpen(true);
  };

  const handleFilterSave = (data: any) => {
    // Update URL parameters instead of state
    const newParams = new URLSearchParams(location.search);
    if (data.group) {
      newParams.set('depotName', data.group);
    } else {
      newParams.delete('depotName');
    }
    if (data.vehicle) {
      newParams.set('vehicleId', data.vehicle);
    } else {
      newParams.delete('vehicleId');
    }

    navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });

    // Call API directly with new data
    const selectedWarningTypes =
      activeTab === 'all' ? allWarningTypes : activeTab === 'critical' ? criticalWarning : nonCriticalWarning;

    fetchAllAlertsParallel(selectedWarningTypes, data.group, data.vehicle);
  };
  const [tilesObj, setTilesObj] = useState<ColumnObjType>({
    Stat1: { name: '# Total Alerts', status: true },
    Stat2: { name: '# Critical Alerts', status: true },
    Stat3: { name: 'Average alerts per driver', status: true },
    Stat4: { name: 'Average Alerts Per day', status: true },
  });
  const [columnObj, setColumnObj] = useState<ColumnObjType>({
    date_time: { name: 'Date and Time', status: true },
    vehicleId: { name: 'Vehicle Reg No', status: true },
    actions: { name: 'Actions', status: true },
    gpsSpeed: { name: 'Last Received Speed', status: true },
  });
  useEffect(() => {
    handleTile(tilesObj);
  }, [tilesObj]);

  const handleToggleWarning = (warningName: string) => {
    setEnabledWarnings((prev) => ({
      ...prev,
      [warningName]: !prev[warningName],
    }));
  };

  const isWarningEnabled = (warningName: string) => {
    // Default to true if not set (warnings are enabled by default)
    return enabledWarnings[warningName] !== false;
  };

  return (
    <Box className="text-gray-800 p-4">
      <Box className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4 gap-4">
        <Box className="flex gap-2 flex-wrap w-full md:w-auto">
          <Box className="flex justify-between items-center w-full md:w-auto overflow-x-auto">
            <Tabs
              value={activeTab}
              onChange={(e, newVal) => setActiveTab(newVal)}
              sx={{
                borderRadius: '8px',
                padding: '4px',
                backgroundColor: theme.palette.selected,
                minWidth: 'fit-content',
                '& .MuiTab-root': {
                  color: 'black !important',
                  minWidth: 'auto',
                  padding: '8px 12px',
                  fontSize: { xs: '12px', md: '14px' },
                },
              }}
              TabIndicatorProps={{ style: { display: 'none' } }}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab
                label="All"
                value="all"
                sx={{
                  ...(activeTab === 'all' && {
                    backgroundColor: theme.palette.background.default,
                    borderRadius: '8px',
                    fontWeight: 600,
                    padding: '8px 16px',
                    boxShadow: '0px 4px 6px #5547DD1A',
                  }),
                }}
              />
              <Tab
                label="Critical"
                value="critical"
                sx={{
                  ...(activeTab === 'critical' && {
                    backgroundColor: theme.palette.background.default,
                    borderRadius: '8px',
                    fontWeight: 600,
                    padding: '8px 16px',
                    boxShadow: '0px 4px 6px #5547DD1A',
                  }),
                }}
              />
              <Tab
                label="Non Critical"
                value="nonCritical"
                sx={{
                  ...(activeTab === 'nonCritical' && {
                    backgroundColor: theme.palette.background.default,
                    borderRadius: '8px',
                    fontWeight: 600,
                    padding: '8px 16px',
                    boxShadow: '0px 4px 6px #5547DD1A',
                  }),
                }}
              />
            </Tabs>
          </Box>
        </Box>

        <Box className="flex gap-1 items-center w-full md:w-auto justify-between md:justify-start">
          <Box className="flex items-center flex-wrap gap-2">
            <CustomIconButton
              icon={<img src={Custom} alt="Custom" width={16} height={16} />}
              text="Customize"
              background="transparent"
              outline={false}
              onClick={handleCustomiseModalOpen}
            />
            <Tabs
              value={viewMode}
              onChange={(e, newVal) => setViewMode(newVal)}
              sx={{
                borderRadius: '8px',
                backgroundColor: theme.palette.grey[100],
                minWidth: 'fit-content',
              }}
              TabIndicatorProps={{ style: { display: 'none' } }}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab
                value="grid"
                icon={
                  <GridTab
                    sx={{
                      color: viewMode === 'grid' ? 'white' : theme.palette.primary.main,
                      height: 30,
                      width: 30,
                      marginBottom: '5px',
                    }}
                  />
                }
                sx={{
                  borderRadius: '8px',
                  ...(viewMode === 'grid' && {
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': {
                      backgroundColor: theme.palette.primary.dark,
                    },
                  }),
                }}
              />
              <Tab
                value="table"
                icon={
                  <TableTab
                    sx={{
                      color: viewMode === 'table' ? 'white' : theme.palette.primary.main,
                      height: 30,
                      width: 30,
                    }}
                  />
                }
                sx={{
                  ml: 1,
                  ...(viewMode === 'table' && {
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': {
                      backgroundColor: theme.palette.primary.dark,
                    },
                  }),
                }}
              />
            </Tabs>
          </Box>
        </Box>

        <Box className="flex gap-1 items-center w-full md:w-auto flex-wrap">
          <div className="relative flex-1 md:flex-none min-w-0">
            <Tooltip
              title={
                selectedDuration === 'Custom Range' ? (
                  <Box
                    sx={{
                      maxWidth: 500,
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontWeight: 700,
                        color: 'text.primary',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Date Range:{' '}
                      <Box
                        component="span"
                        sx={{
                          color: '#235AF9',
                          maxWidth: '100%',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {startDate} - {endDate}
                      </Box>
                    </Typography>
                  </Box>
                ) : null
              }
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: 'background.paper',
                    color: 'text.primary',
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
                    borderRadius: '8px',
                    padding: '8px 12px',
                    maxWidth: 'none', // Remove default max-width constraint
                    '& .MuiTooltip-arrow': {
                      color: 'background.paper',
                    },
                  },
                },
              }}
              arrow
            >
              <Button
                onClick={handleClick}
                variant="outlined"
                sx={{
                  height: { xs: '28px', sm: '30px', md: '48px' },
                  px: { xs: 1, sm: 2 },
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: 700,
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: { xs: 0.5, sm: 1 },
                  borderColor: '#5547dd',
                  backgroundColor: 'white',
                  color: '#5547dd',
                  minWidth: 0,
                  maxWidth: '100%',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <img src={calendar} alt="Calendar" width={18} height={18} />
                  <Box sx={{ display: 'block', maxWidth: '100%' }}>
                    <Typography
                      variant="body2"
                      sx={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {selectedDuration}
                    </Typography>
                  </Box>
                  <img src={arrow} alt="Arrow" width={18} height={18} />
                </Box>
              </Button>
            </Tooltip>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => handleClose()}
              PaperProps={{
                sx: {
                  borderRadius: '8px',
                  top: '10px',
                  boxShadow: '0 6px 10px rgba(0, 0, 0, 0.1)',
                },
              }}
            >
              {dateRangeArr.map((label) => (
                <MenuItem
                  key={label}
                  onClick={() => handleClose(label)}
                  sx={(theme) => ({
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                      backgroundColor: theme.palette.action.hover,
                    },
                    backgroundColor: selectedDuration === label ? theme.palette.selected : 'transparent',
                  })}
                >
                  <Typography variant="button" textTransform={'none'}>
                    {label}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
            <Menu
              anchorEl={calendarAnchorEl}
              open={showDatePicker}
              onClose={handleCalendarClose}
              slotProps={{
                paper: {
                  sx: {
                    borderRadius: '8px',
                    top: '10px',
                    padding: '0px',
                    boxShadow: '0 6px 10px rgba(0, 0, 0, 0.1)',
                  },
                },
              }}
            >
              <DateRangeFilter
                onCancel={handleCalendarClose}
                onApply={(from, to) => {
                  setStartDate(from);
                  setStartTileDate(from);
                  setEndTileDate(to);
                  setEndDate(to);
                  setSelectedDuration('Custom Range');
                  setShowDatePicker(false);
                  setCalendarAnchorEl(null);
                }}
                initialFrom={startDate}
                initialTo={endDate}
              />
            </Menu>
          </div>
          {/* <div className="max-w-[400px]">
							<TextField
								variant="outlined"
								value={searchQuery}
								onChange={(e) => setSearchQuery(e.target.value)}
								placeholder="Search"
								sx={(theme) => ({
									"& .MuiOutlinedInput-root": {
										borderColor: theme.palette.action.selected,
										borderRadius: '8px',
										display: 'flex',
										alignItems: 'center',
										height: '100%', // Ensure it takes full available height
									},
									"& .MuiInputBase-root": {
										padding: '0rem 1rem'
									},
									"& .MuiOutlinedInput-input": {
										padding: '0px 12px', // Adjust padding for better spacing
										height: '48px',
										display: 'flex',
										alignItems: 'center',
									},
								})}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<img src={searchIcon} alt="icon" width={16} height={16} />
										</InputAdornment>
									),
									endAdornment: (
										<InputAdornment
											position="end"

											sx={(theme) => ({
												height: '48px', // Ensure full height
												maxHeight: '48px',
												display: 'flex',
												cursor: 'pointer',
												alignItems: 'center',
												borderLeft: `1px solid ${theme.palette.action.selected}`,
												paddingLeft: '8px',
											})}
										>
											<img src={filterIcon} onClick={handleFilterOpen} alt="icon" width={24} height={24} />
										</InputAdornment>
									),
								}}
								inputProps={{
									style: {
										display: 'flex',
										alignItems: 'center',
										fontSize: '14px', // You can adjust this as per Typography variant
										fontWeight: 500, // Normal text weight
									},
								}}
							/>
						</div> */}

          <Button
            variant="outlined"
            onClick={() => setIsFilterModelOpen(true)}
            startIcon={<img src={filterIcon} alt="Filter" width={24} height={24} />}
            sx={{
              height: '48px',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 700,
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              borderColor: '#5547dd',
              backgroundColor: 'white',
              color: '#5547dd',
              padding: '0 16px',
              minWidth: 'fit-content',
              flexShrink: 0,
            }}
          >
            <span className="hidden sm:inline">Filter Data</span>
            <span className="sm:hidden">Filter</span>
          </Button>
        </Box>
      </Box>

      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        {selectedDuration === 'Custom Range' && startDate && endDate && (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              background: '#F5F7FF',
              borderRadius: '8px',
              py: 1,
              px: 2,
              boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
              fontWeight: 500,
            }}
          >
            <Typography variant="body2" sx={{ color: '#235AF9', fontWeight: 700 }}>
              {dayjs(startDate).format('DD/MM/YYYY')} - {dayjs(endDate).format('DD/MM/YYYY')}
            </Typography>
            <IconButton
              size="small"
              onClick={() => {
                setStartDate('');
                setEndDate('');
                setSelectedDuration(dateRangeArr[0]);
              }}
              sx={{
                color: 'error.main',
                background: '#fff',
                borderRadius: '50%',
                fontSize: '16px',
                width: 22,
                height: 22,
                ml: 1,
                boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
              }}
              title="Clear date range"
            >
              &#10005;
            </IconButton>
          </Box>
        )}
      </Box>

      {/* Warnings List */}
      {loading ? (
        <Loader />
      ) : (
        <Box className={`${viewMode === 'table' ? 'grid grid-cols-1 md:grid-cols-2 gap-4' : 'space-y-8'}`}>
          {newData
            ?.filter(
              (warning) => isWarningEnabled(warning.warningName) && !shouldHideWarning(warning.warningName),
            )
            .map((warning: any, index) => {
              return (
                <Box
                  key={warning.warningName + index}
                  className={`${viewMode === 'table' ? 'w-full bg-white rounded-lg shadow-sm' : 'space-y-4'}`}
                >
                  {/* Warning Header */}
                  <Box
                    className="flex flex-col md:flex-row justify-between items-start md:items-center bg-white p-2 rounded-lg gap-2"
                    sx={{ opacity: 1 }}
                  >
                    <Box className="flex items-center gap-2 flex-wrap">
                      <img src={getWarningIcon(warning.warningName)} />
                      <Typography
                        variant="h6"
                        className={`font-semibold ${warning.warningName === 'SOS' ? 'text-red-500' : ''}`}
                        sx={{
                          fontFamily: 'Inter Tight',
                          fontWeight: 400,
                          fontSize: { xs: '14px', md: '16px' },
                          lineHeight: '18px',
                          letterSpacing: '0%',
                          textTransform: 'uppercase',
                          color: warning.warningName === 'SOS' ? 'red' : '#767676',
                        }}
                      >
                        {warning.warningName.toUpperCase()}
                      </Typography>
                      <img
                        src={infoIcon}
                        alt="info icon"
                        title="More info"
                        className="w-4 h-4 cursor-pointer"
                      />
                      <Chip
                        label={warning.totalRecords || 0}
                        size="small"
                        sx={{
                          height: 24,
                          gap: '10px',
                          borderRadius: '4px',
                          backgroundColor: '#EAE9F5',
                          color: 'black',
                          width: `${Math.max(40, 24 + String(warning.totalRecords || 0).length * 8)}px`,
                          whiteSpace: 'nowrap',
                          overflow: 'visible',
                          textOverflow: 'clip',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      />
                      <Box
                        sx={{
                          width: warning.isCritical ? 57 : 100,
                          height: 24,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: warning.isCritical ? '10px' : '4px',
                          borderRadius: '8px',
                          padding: '4px 8px',
                          backgroundColor: warning.isCritical ? '#F7E1E1' : '#FFF4E1',
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: 'Inter Tight',
                            fontWeight: 400,
                            fontSize: '12px',
                            lineHeight: '21px',
                            letterSpacing: '0%',
                            color: warning.isCritical ? '#C83333' : '#A9861E',
                          }}
                        >
                          {warning.isCritical ? 'Critical' : 'Non Critical'}
                        </Typography>
                      </Box>
                    </Box>

                    <Box className="flex items-center bg-white p-3 rounded-lg shadow-sm w-full md:w-auto justify-between md:justify-start">
                      <Button
                        variant="outlined"
                        onClick={() => handleViewAll(warning.warningName)}
                        endIcon={<CallMadeIcon />}
                        disabled={false}
                        sx={{
                          minWidth: { xs: 'auto', md: 'auto' },
                          padding: { xs: '8px', md: '8px 16px' },
                        }}
                      >
                        <span className="hidden sm:inline">View All</span>
                      </Button>

                      <Box className="flex items-center gap-2 ml-4">
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            className="sr-only peer"
                            checked={true}
                            onChange={() => handleToggleWarning(warning.warningName)}
                          />
                          <Box
                            className="w-12 h-6 flex items-center rounded-full transition-colors duration-300 ease-in-out"
                            sx={{
                              backgroundColor: theme.palette.primary.main,
                              opacity: 1,
                            }}
                          >
                            <div
                              className={`bg-white w-5 h-5 rounded-full shadow-md transform transition-transform duration-300 translate-x-6`}
                            />
                          </Box>
                        </label>
                      </Box>
                    </Box>
                  </Box>

                  {/* Render alerts for enabled warnings */}
                  {viewMode === 'grid' ? (
                    warning.alerts?.length > 0 ? (
                      <AlertsGrid alerts={warning.alerts} />
                    ) : (
                      <Box className="p-4 text-center text-gray-500">No records found for this warning</Box>
                    )
                  ) : viewMode === 'table' ? (
                    warning.alerts?.length > 0 ? (
                      <AlertsTable
                        alerts={warning.alerts}
                        warning={warning.warningName}
                        startDate={startDate}
                        endDate={endDate}
                        columnObj={columnObj}
                        filters={filters}
                        search={searchQuery}
                        filterData={filterData}
                      />
                    ) : (
                      <Box className="p-4 text-center text-gray-500">No records found for this warning</Box>
                    )
                  ) : (
                    <Box className="p-4 text-center text-gray-500">No alerts found for this warning type</Box>
                  )}
                </Box>
              );
            })}

          {/* Then render disabled warnings at the end */}
          {newData
            ?.filter(
              (warning) => !isWarningEnabled(warning.warningName) && !shouldHideWarning(warning.warningName),
            )
            .map((warning: any, index) => {
              return (
                <Box
                  key={warning.warningName + index}
                  className={`${viewMode === 'table' ? 'w-full bg-white rounded-lg shadow-sm' : 'space-y-4'}`}
                  sx={{ opacity: 0.5 }}
                >
                  {/* Warning Header */}
                  <Box className="flex flex-col md:flex-row justify-between items-start md:items-center bg-white p-2 rounded-lg gap-2">
                    <Box className="flex items-center gap-2 flex-wrap">
                      <img src={getWarningIcon(warning.warningName)} />
                      <Typography
                        variant="h6"
                        className={`font-semibold ${warning.warningName === 'SOS' ? 'text-red-500' : ''}`}
                        sx={{
                          fontFamily: 'Inter Tight',
                          fontWeight: 400,
                          fontSize: { xs: '14px', md: '16px' },
                          lineHeight: '18px',
                          letterSpacing: '0%',
                          textTransform: 'uppercase',
                          color: warning.warningName === 'SOS' ? 'red' : '#767676',
                        }}
                      >
                        {warning.warningName.toUpperCase()}
                      </Typography>
                      <img
                        src={infoIcon}
                        alt="info icon"
                        title="More info"
                        className="w-4 h-4 cursor-pointer"
                      />
                      <Chip
                        label={warning.totalRecords || 0}
                        size="small"
                        sx={{
                          height: 24,
                          gap: '10px',
                          borderRadius: '4px',
                          backgroundColor: '#EAE9F5',
                          color: 'black',
                          width: `${Math.max(40, 24 + String(warning.totalRecords || 0).length * 8)}px`,
                          whiteSpace: 'nowrap',
                          overflow: 'visible',
                          textOverflow: 'clip',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      />
                      <Box
                        sx={{
                          width: warning.isCritical ? 57 : 100,
                          height: 24,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: warning.isCritical ? '10px' : '4px',
                          borderRadius: '8px',
                          padding: '4px 8px',
                          backgroundColor: warning.isCritical ? '#F7E1E1' : '#FFF4E1',
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: 'Inter Tight',
                            fontWeight: 400,
                            fontSize: '12px',
                            lineHeight: '21px',
                            letterSpacing: '0%',
                            color: warning.isCritical ? '#C83333' : '#A9861E',
                          }}
                        >
                          {warning.isCritical ? 'Critical' : 'Non Critical'}
                        </Typography>
                      </Box>
                    </Box>

                    <Box className="flex items-center bg-white p-3 rounded-lg shadow-sm w-full md:w-auto justify-between md:justify-start">
                      <Button
                        variant="outlined"
                        onClick={() => handleViewAll(warning.warningName)}
                        endIcon={<CallMadeIcon />}
                        disabled={true}
                        sx={{
                          minWidth: { xs: 'auto', md: 'auto' },
                          padding: { xs: '8px', md: '8px 16px' },
                        }}
                      >
                        <span className="hidden sm:inline">View All</span>
                      </Button>

                      <Box className="flex items-center gap-2 ml-4">
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            className="sr-only peer"
                            checked={false}
                            onChange={() => handleToggleWarning(warning.warningName)}
                          />
                          <Box
                            className="w-12 h-6 flex items-center rounded-full transition-colors duration-300 ease-in-out"
                            sx={{
                              backgroundColor: theme.palette.secondary.main,
                              opacity: 0.7,
                            }}
                          >
                            <div
                              className={`bg-white w-5 h-5 rounded-full shadow-md transform transition-transform duration-300 translate-x-1`}
                            />
                          </Box>
                        </label>
                      </Box>
                    </Box>
                  </Box>

                  {/* Don't render alerts for disabled warnings */}
                </Box>
              );
            })}
        </Box>
      )}
      <FilterDataModel
        open={isFilterModel}
        onClose={handleFilterClose}
        handleFilterSave={handleFilterSave}
        title="Filter"
        description="Use the options below to refine your search and find specific alerts quickly."
        showTripStatus={false}
        onReset={() => {
          const newParams = new URLSearchParams(location.search);
          newParams.delete('group');
          newParams.delete('vehicleId');
          navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
        }}
        showClearButton={Boolean(urlFilters.group || urlFilters.vehicle)}
        initialFilters={{
          group: urlFilters.group ?? null,
          vehicle: urlFilters.vehicle ?? null,
        }}
        trgtcData={true}
      />
      <CustomiseTableModal
        open={isCustomiseModalOpen}
        onClose={() => setIsCustomiseModalOpen(false)}
        onReset={() => {}}
        title="Customize Your Table"
        description="Select and arrange table columns as you prefer."
        columnObj={columnObj}
        setColumnObj={setColumnObj}
        tilesObj={tilesObj}
        setTilesObj={setTilesObj}
      />
    </Box>
  );
};

export default Dashboard;
